import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from "../components/layout/logo.png";

function LoginPage() {
  const history = useHistory();
  const { login, loading } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    username: "",
    password: ""
  });

  async function handleSubmit(event) {
    event.preventDefault();
    const success = await login(form);

    if (success) {
      history.push("/");
    }
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setForm((current) => ({
      ...current,
      [name]: value
    }));
  }

  return (
    <div className="login-page">
      <div className="login-shell">
        <section className="login-hero">
          <div className="login-brand">
            <div className="login-brand-mark" aria-hidden="true">
              <img src={logo} alt="" className="login-brand-image" />
            </div>

            <div className="login-brand-copy">
              <p className="login-brand-country">Republic of Uganda</p>
              <h1 className="login-brand-ministry">Ministry of Health</h1>
            </div>
          </div>

          <div className="login-hero-copy">
            <p className="page-eyebrow">UNEPI workspace</p>
            <h2 className="login-hero-title">UNEPI Workplan Tracker</h2>
            <p className="login-hero-text">Integrated planning and task tracking for UNEPI teams.</p>
          </div>
        </section>

        <section className="login-card">
          <p className="page-eyebrow">Sign in</p>
          <h3 className="login-card-title">Account Access</h3>
          <p className="login-card-text">Use your UNEPI account credentials to continue.</p>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="form-label login-label">Username</label>
              <input
                className="form-control login-input"
                name="username"
                value={form.username}
                onChange={handleChange}
                placeholder="Enter username"
                autoComplete="username"
                required
              />
            </div>

            <div className="mb-4">
              <label className="form-label login-label">Password</label>
              <div className="login-password-field">
                <input
                  className="form-control login-input"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  className="login-password-toggle"
                  onClick={() => setShowPassword((current) => !current)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`} />
                </button>
              </div>
            </div>

            <div className="login-meta-row">
              <label className="login-checkbox">
                <input type="checkbox" disabled />
                <span>Remember me</span>
              </label>
            </div>

            <button className="btn btn-primary w-100 login-submit" disabled={loading} type="submit">
              {loading ? "Signing in..." : "Login"}
            </button>
          </form>
        </section>
      </div>
    </div>
  );
}

export default LoginPage;
